import { Card, CardBody, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { BillingDetails, Checkout, Ecommerce } from "../../../Constant";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import CheckoutTableData from "./CheckoutTableData";
import ProductPlaceOrder from "./ProductPlaceOrder";

const CheckOutContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={Checkout} parent={Ecommerce} title={Checkout} />
      <Container fluid>
        <Card>
          <CommonCardHeader title={BillingDetails} />
          <CardBody>
            <Row>
              <CheckoutTableData />
              <ProductPlaceOrder/>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default CheckOutContainer;
